/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarnings
 */
export interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarnings {
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'detectedDpi'?: OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'calculatedDpi'?: OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'colorGradation'?: OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'heightMillis'?: OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'widthMillis'?: OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum;
}

export const OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum = typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum[keyof typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum];
export const OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum = typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum[keyof typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum];
export const OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum = typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum[keyof typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum];
export const OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum = typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum[keyof typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum];
export const OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum = typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum[keyof typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum];


